import React from "react";

interface MarkUnreadIconProps {
  size?: number;
  color?: string;
}

export default function MarkUnreadIcon({
  size = 20,
  color = "#79808A",
}: MarkUnreadIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4609 4.89941L12.4502 5.00977C12.4175 5.33359 12.4332 5.66055 12.498 5.97949L12.5225 6.09961H4.16699C3.89928 6.09962 3.64127 6.20049 3.44434 6.38184C3.24754 6.56314 3.12558 6.81145 3.10352 7.07812L3.09961 7.16992V7.74707L9.33301 10.9893L14.4092 8.35059L14.4492 8.3291L14.4912 8.3457C14.8558 8.48792 15.2524 8.56637 15.667 8.56641C15.996 8.56668 16.3238 8.5164 16.6377 8.41797L16.7676 8.37695V14.833C16.7676 15.4118 16.5459 15.9688 16.1484 16.3896C15.7508 16.8105 15.207 17.0639 14.6289 17.0967H14.626L14.5029 17.0996H4.16699C3.58803 17.0996 3.0312 16.8781 2.61035 16.4805C2.18959 16.0829 1.93618 15.5398 1.90332 14.9619V14.959L1.90039 14.8359V7.16602C1.90037 6.58704 2.12191 6.03021 2.51953 5.60938C2.91709 5.18865 3.46018 4.9352 4.03809 4.90234H4.04102L4.16406 4.89941H12.4609ZM9.61035 12.1982C9.53941 12.2351 9.46152 12.2572 9.38184 12.2637C9.30232 12.2701 9.22228 12.2612 9.14648 12.2363L9.13867 12.2334L9.06445 12.2021L9.05664 12.1992V12.1982L3.09961 9.10059V14.833C3.09962 15.1006 3.20059 15.3588 3.38184 15.5557C3.56318 15.7526 3.8123 15.8745 4.0791 15.8965H4.07812L4.1709 15.9004H14.501C14.7686 15.9003 15.0268 15.7995 15.2236 15.6182C15.4206 15.4367 15.5416 15.1868 15.5635 14.9199L15.5674 14.833V9.10059L9.61035 12.1982ZM14.7285 3.08789C15.1166 2.92577 15.5404 2.86764 15.958 2.91797C16.3755 2.96834 16.773 3.12537 17.1113 3.375C17.4498 3.62472 17.7174 3.95861 17.8887 4.34277C18.0599 4.72687 18.1293 5.14879 18.0889 5.56738C18.0484 5.986 17.8998 6.38718 17.6582 6.73145C17.4166 7.07563 17.0898 7.35188 16.71 7.53223C16.3929 7.68247 16.0471 7.7624 15.6963 7.7666C15.3453 7.77075 14.9974 7.69845 14.6768 7.55566C14.3561 7.41282 14.0696 7.2022 13.8379 6.93848C13.6064 6.67489 13.4343 6.36448 13.334 6.02832C13.2346 5.6939 13.2083 5.34154 13.2568 4.99609L13.2578 4.98926V4.98535C13.318 4.5691 13.4855 4.1752 13.7432 3.84277C14.0009 3.51032 14.3404 3.25004 14.7285 3.08789Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  );
}
